/**
 * PostHog helper for the lab.
 *
 * PostHog is only loaded in production (app/views/layouts/_posthog.html.haml), so every call
 * is a no-op when `window.posthog` is missing, and analytics must never break the lab.
 */
export const captureEvent = (name, properties = {}) => {
  if (typeof window === 'undefined') return;
  const posthog = window.posthog;
  if (!posthog || typeof posthog.capture !== 'function') return;
  try {
    posthog.capture(name, properties);
  } catch (e) {
    // Analytics failures are not the user's problem
  }
};
